/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var $ = require("jquery");
var jQueryBridget = require("jquery-bridget");
var Flickity = require("flickity");
require("simplelightbox");

Flickity.setJQuery($);
jQueryBridget("flickity", Flickity, $);


(function ($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
    var Sage = {
        // All pages
        common: {
            init: function () {
    

                // Mobile navigation hamburger
                $('.opennav').on('click', function() {
                    $(this).toggleClass('active');
                    $('#nav').toggle();
                });
                
                if (window.matchMedia('(max-width: 1050px)').matches) {
                    $('.menu > li.menu-item-has-children > a').on('click', function(e) {
                        e.preventDefault();
                        $(this).parent().children('.sub-menu').toggle();
                    });
                }


                // Remove broken aria-hidden on flickity
                function removeAriaADA() {
                    $('.flickity-cell').removeAttr('aria-hidden');
                }


                // Hero slideshow
                var heroslider = $('.heroslideshow');
                heroslider.on('ready.flickity', removeAriaADA);
                heroslider.on('change.flickity', removeAriaADA);
                heroslider.flickity({
                    wrapAround: true,
                    prevNextButtons: false,
                    cellAlign: 'left',
                    lazyLoad: 1,
                    autoPlay: 8000,
                    pauseAutoPlayOnHover: false
                });


                // Multi-image slider
                var imgslider = $('.slider-multiple');
                imgslider.on('ready.flickity', removeAriaADA);
                imgslider.on('change.flickity', removeAriaADA);
                imgslider.flickity({
                    wrapAround: true,
                    prevNextButtons: false,
                    imagesLoaded: true,
                    groupCells: true
                });


                // Image gallery slider
                $(".imagegallery").each(function() {
                    var slidecount = $(this).attr("data-slidecount");
                    if (slidecount <= 4) {
                        if (matchMedia('screen and (max-width: 1050px)').matches) {
                            var imggal = $(this);
                            imggal.on('ready.flickity', removeAriaADA);
                            imggal.on('change.flickity', removeAriaADA);
                            imggal.flickity({
                                prevNextButtons: true,
                                draggable: true,
                                pageDots: false,
                                contain: true,
                                groupCells: true
                            });
                        }
                        else {
                            var imggal = $(this);
                            imggal.on('ready.flickity', removeAriaADA);
                            imggal.on('change.flickity', removeAriaADA);
                            imggal.flickity({
                                prevNextButtons: false,
                                draggable: false,
                                pageDots: false,
                                contain: true
                            });
                        }
                    }
                    else {
                        var imggal = $(this);
                        imggal.on('ready.flickity', removeAriaADA);
                        imggal.on('change.flickity', removeAriaADA);
                        imggal.flickity({
                            prevNextButtons: true,
                            pageDots: false,
                            cellAlign: 'left',
                            contain: true,
                            groupCells: true
                        });
                    }
                });
                


                // Single quote slider
                $('.slider-one').flickity({
                    wrapAround: true,
                    prevNextButtons: false,
                    imagesLoaded: true,
                    autoPlay: 4000,
                    pauseAutoPlayOnHover: true
                });


                // Project Filter Toggle
                $('.filters a').on('click', function(e) {
                    e.preventDefault();
                    $('.filters a').removeClass('active');
                    $(this).addClass('active');
                    var href = $(this).attr('href');
                    filter = href.substring(1, href.length);
                    console.log(filter);
                    $('.allcat').hide();
                    $('.'+filter).show();
                });


                // Fullwidth Video
                $('.playvideo').on('click', function(){
                    if ($(this).data("youtube")) {
                        var youtubeid = $(this).data("youtube");
                        $(this).parent().html('<iframe width="100%" height="400" src="https://www.youtube-nocookie.com/embed/'+youtubeid+'?autoplay=1&color=white" frameborder="0" allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>');
                    }
                    else {
                        var mp4 = $(this).data("mp4");
                        var source = '<source src="'+mp4+'" type="video/mp4" />';
                        if ($(this).data("webm")) var source = source+'<source src="'+$(this).data("webm")+'" type="video/webm" />';
                        $(this).parent().html('<video autoplay controls controlsList="nodownload">'+source+'</video>');
                    }
                });


                // Image Galleries
                function lightboxalt() {
                    var pagetitle = $('h1').text();
                    $('.sl-image img').attr('alt', pagetitle);
                }
                let lightbox = new SimpleLightbox('.imagegallery a', {
                    showCounter: false,
                    doubleTapZoom: 1,
                    scrollZoom: false
                });
                lightbox.on('shown.simplelightbox', lightboxalt);
                lightbox.on('changed.simplelightbox', lightboxalt);


                // Anchor link adjust
                function offsetAnchor() {
                    if(location.hash.length !== 0) {
                        var headerheight = $('header').height();
                        if (window.matchMedia('(max-width: 1050px)').matches) headerheight = 0;
                        window.scrollTo(window.scrollX, window.scrollY - headerheight - 5);
                    }
                }
                window.addEventListener("hashchange", offsetAnchor);
                window.setTimeout(offsetAnchor, 1);



                // MAP AND PORTFOLIO
                $('#map-toggle input').on('change', function() {
                    var maptogglechoice = $('#map-toggle input[name="toggleview"]:checked').val();
                    $('#map-toggle label').show();
                    $(this).parent('label').hide();
                    if (maptogglechoice == "map") {
                        $('.loader').fadeIn();
                        $('.view-projects').hide();
                        $('.project-grid').html('');
                        $('#loadmore-projects').hide();
                        $('.view-map').show();
                        setTimeout(function() {
                            getMapFilter();
                            $('.loader').fadeOut();
                        }, 800);
                    }
                    else {
                        $('.view-projects').show();
                        $('.view-map').hide();
                        getPortfolioFilter(0);
                    }
                });

                // Search Projects
                $('#submit-search').on('click', function() {
                    var maptogglechoice = $('#map-toggle input[name="toggleview"]:checked').val();
                    if (maptogglechoice === "map") getMapFilter();
                    else getPortfolioFilter(0);
                });

                // Load More Projects
                $('#loadmore-projects').on('click', function() {
                    var projectsShowing = $('.project-grid').data('showing');
                    getPortfolioFilter(projectsShowing);
                });

                // Project Filter
                $('.map-filters input').on('change', function() {
                    $('.map-filter #map-category label').removeClass('active');
                    $('.map-filter #map-tag label').removeClass('active');
                    $('.map-filter #map-category input[name="category"]:checked').parent('label').addClass('active');
                    $('.map-filter #map-tag input[name="tag[]"]:checked').parent('label').addClass('active');
                    var maptogglechoice = $('#map-toggle input[name="toggleview"]:checked').val();
                    if (maptogglechoice == "map") getMapFilter();
                    else getPortfolioFilter(0);
                });

                function getPortfolioFilter(startat = 12) {
                    $('.loader').fadeIn();
                    const category_id = $('.map-filter #map-category input[name="category"]:checked').val();
                    const tag_ids = $('.map-filter #map-tag input[name="tag[]"]:checked').map(function() {
                        return this.value;
                    }).get();
                    const search_term = $('#portfolio-search').val();
                    $.ajax({
                        url: ajax_object.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'load_more_portfolio',
                            category_id: category_id,
                            tag_ids: tag_ids,
                            search_term: search_term,
                            startat: startat
                        },
                        success: function(response) {
                            const projectList = JSON.parse(response);
                            var totalPosts = projectList.total;
                            var projects = projectList.projects;
                            var newprojects = '';
                            projects.forEach(project => {
                                newprojects += project;
                            });
                            if (startat == 0) {
                                $('.project-grid').html(newprojects);
                            }
                            else {
                                $('.project-grid').append(newprojects);
                            }
                            setTimeout(function() {
                                $('.loader').fadeOut();
                                $('.project-grid .project').removeClass('loadin');
                            }, 800);
                            var datashowing = startat + 12;
                            $('#loadmore-projects').data('total', totalPosts);
                            $('.project-grid').data('showing', datashowing);
                            if (datashowing >= totalPosts) {
                                $('#loadmore-projects').hide();
                            }
                            else {
                                $('#loadmore-projects').fadeIn();
                            }
                            if (totalPosts <= 0) {
                                $('.noresults').show();
                            }
                            else {
                                $('.noresults').hide();
                            }
                        }
                    });
                }

                function getMapFilter() {
                    const category_id = $('.map-filter #map-category input[name="category"]:checked').val();
                    const tag_ids = $('.map-filter #map-tag input[name="tag[]"]:checked').map(function() {
                        return this.value;
                    }).get();
                    const search_term = $('#portfolio-search').val();
                    const map_api = $('.map-filter #map-api').val();
                    
                    $.ajax({
                        url: ajax_object.ajax_url,
                        type: 'POST',
                        data: {
                            action: 'filter_map',
                            category_id: category_id,
                            tag_ids: tag_ids,
                            search_term: search_term,
                            apikey: map_api
                        },
                        success: function(response) {
                            const locList = JSON.parse(response);
                            updateMapMarkers(locList);
                        }
                    });
                }
                
                function updateMapMarkers(locList) {
                    // Clear existing markers
                    markers.forEach(marker => marker.setMap(null));
                    markers = [];

                    if (markerClusters) {
                        markerClusters.clearMarkers();
                    }
                
                    // Add new markers
                    let currentInfoWindow = null;
                    locList.forEach(location => {
                        console.log(location.caticon);
                        const marker = new google.maps.Marker({
                            position: new google.maps.LatLng(location.lat, location.lng),
                            map: map,
                            title: location.title,
                            icon: {
                                url: location.caticon
                            }
                        });
                
                        const infowindow = new google.maps.InfoWindow({
                            content: '<div class="infowindows">' + location.desc + '</div>'
                        });
                        marker.addListener("click", () => {
                            if (currentInfoWindow) {
                                currentInfoWindow.close();
                            }
                            infowindow.open({
                                anchor: marker,
                                map: map,
                                shouldFocus: false
                            });
                            currentInfoWindow = infowindow;
                        });
                
                        markers.push(marker);
                    });

                    const renderer = {
                        render: ({ count, position }) =>
                        new google.maps.Marker({
                            label: { 
                                text: String(count), 
                                color: "white", 
                                fontSize: "14px", 
                                fontWeight: "bold", 
                                textAlign: "center", 
                                width: "100%" 
                            },
                            icon: {
                                url: `/wp-content/themes/bothman/dist/images/map-cluster-60.png`,
                                scaledSize: new google.maps.Size(45, 45),
                            },
                            position,
                            zIndex: Number(google.maps.Marker.MAX_ZINDEX) + count,
                        }),
                    };
                    markerClusters = new markerClusterer.MarkerClusterer({ 
                        map,
                        markers,
                        renderer
                    });

                }
            }

        },
        // Home page
        home: {
          init: function () {
            // JavaScript to be fired on the home page
          },
          finalize: function () {
            // JavaScript to be fired on the home page, after the init JS
          },
        }
    };
    // The routing fires all common scripts, followed by the page specific scripts.
    // Add additional events for more control over timing e.g. a finalize event
    var UTIL = {
        fire: function (func, funcname, args) {
        var fire;
        var namespace = Sage;
        funcname = funcname === undefined ? "init" : funcname;
        fire = func !== "";
        fire = fire && namespace[func];
        fire = fire && typeof namespace[func][funcname] === "function";

        if (fire) {
            namespace[func][funcname](args);
        }
        },
        loadEvents: function () {
        // Fire common init JS
        UTIL.fire("common");

        // Fire page-specific init JS, and then finalize JS
        $.each(
            document.body.className.replace(/-/g, "_").split(/\s+/),
            function (i, classnm) {
            UTIL.fire(classnm);
            UTIL.fire(classnm, "finalize");
            }
        );

        // Fire common finalize JS
        UTIL.fire("common", "finalize");
        },
    };

    // Load Events
    $(document).ready(UTIL.loadEvents);
})(jQuery); // Fully reference jQuery after this point.

